'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFullCart = exports.fetchInlineCart = undefined;

var _Dom = require('common/Dom.js');

var _Dom2 = _interopRequireDefault(_Dom);

var _FreeGift = require('components/FreeGift');

var _FreeGift2 = _interopRequireDefault(_FreeGift);

var _AnimatedButtons = require('components/AnimatedButtons');

var _AnimatedButtons2 = _interopRequireDefault(_AnimatedButtons);

var _handlers = require('./handlers');

var _DataLayer = require('../DataLayer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingTime = 400;

var setCartIndicator = function setCartIndicator() {
  var cartIndicatorWrapper = document.querySelector('[' + _Dom2.default.indicatorWrapper + ']');
  var cartIndicator = document.querySelector('[' + _Dom2.default.indicator + ']');

  var numberOfItemsInCart = CartJS.cart.item_count;

  if (cartIndicatorWrapper !== null && cartIndicator !== null) {
    if (numberOfItemsInCart > 0) {
      cartIndicatorWrapper.classList.remove('hidden');
    } else {
      cartIndicatorWrapper.classList.add('hidden');
    }

    cartIndicator.innerText = numberOfItemsInCart;
  }
};

/**
 * Loads the inline cart via AJAX call to the server
 *
 * @param {boolean} animateLoad: whether to add animation to the items while loading them
 */
var fetchInlineCart = exports.fetchInlineCart = function fetchInlineCart() {
  var animateLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  fetch('/cart?view=ajax-inline-cart').then(function (blob) {
    return blob.text();
  }).then(function (content) {
    var inlineCartWrapper = document.querySelector(_Dom2.default.inlineCartContents);
    inlineCartWrapper.innerHTML = content;

    var lineItems = inlineCartWrapper.querySelectorAll('[data-item-id], [data-upsell-product], [data-free-gift]') || [];
    lineItems.forEach(function (lineItem, index) {
      // check if we should setup free gift ATC event listener
      if (lineItem.hasAttribute('data-free-gift')) {
        _FreeGift2.default.setup();
      }

      // check if we should animate the line items & upsell
      if (animateLoad !== false) {
        lineItem.classList.add('line-item--lazy');
        setTimeout(function () {
          lineItem.classList.add('loaded');
        }, index * loadingTime);
      }
    });
  }).then(function () {
    (0, _handlers.setCartAbandonedTime)();
    setCartIndicator();
    _AnimatedButtons2.default.setupAnimatedCheckout();

    var yotpoCart = document.querySelector('.customer-logged-in [data-yotpo-loyalty-cart-wrapper]');
    if (yotpoCart !== null) {
      (0, _handlers.setYotpoLoyaltyCart)();
    }
  }).then(function () {
    return (0, _DataLayer.trackCartScripApplied)(loadingTime);
  });
};

/**
 * Will make an AJAX request to get the full cart page contents
 */
var fetchFullCart = exports.fetchFullCart = function fetchFullCart() {
  var cartContentsElement = document.querySelector('[data-full-cart-contents]') || false;
  cartContentsElement && fetch('/cart?view=ajax-cart').then(function (blob) {
    return blob.text();
  }).then(function (content) {
    cartContentsElement.innerHTML = content;
  });
};